import React from "react";

export default function Certs({content}) {

    if (!content.certs) {
        return ("");
    }

    const hygieneImg = ((content.certs.hygiene && content.certs.hygiene !== '-') ? "/static_content/hygiene/" + content.certs.hygiene + ".png" : null)

    return(
        <div>
            {hygieneImg ? <img src={hygieneImg} alt="hygiene rating"/> : ""}
        </div>
    )
}